"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _createStyles = _interopRequireDefault(require("@material-ui/core/styles/createStyles"));
var _makeStyles = _interopRequireDefault(require("@material-ui/core/styles/makeStyles"));
var _animation = require("./animation.utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var styles = (0, _makeStyles.default)(theme => (0, _createStyles.default)(_objectSpread(_objectSpread(_objectSpread({}, (0, _animation.getKeyFrames)((0, _animation.glitchOneConfig)())), (0, _animation.getKeyFrames)((0, _animation.glitchTwoConfig)())), {}, {
  // Use a set of different keyframe configs for mobile
  [theme.breakpoints.down('sm')]: _objectSpread(_objectSpread({}, (0, _animation.getKeyFrames)((0, _animation.glitchOneConfig)(true))), (0, _animation.getKeyFrames)((0, _animation.glitchTwoConfig)(true))),
  glitch: _objectSpread({
    position: 'relative',
    width: '100%',
    height: '100%'
  }, (0, _animation.glitchImage)(_animation.glitchImgOneConfig)),
  glitch2: _objectSpread({
    position: 'relative',
    width: '100%',
    height: '100%'
  }, (0, _animation.glitchImage)(_animation.glitchImgTwoConfig)),
  imageCopy: {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0
  }
})), {
  name: 'BrandLogo'
});
var _default = exports.default = styles;